export default __webpack_public_path__ + "static/media/icons8-bulleted-list-90.6e5755a0.svg";